import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/Sidebar';
import { MangaGenerationTab } from '../../components/image-generation';
import { BookOpen } from 'lucide-react';
import { ResponsiveAppShell, TaskyTopBar, TaskyPageContainer } from '../../components/tasky';

const MangaAdsPage: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <ResponsiveAppShell
      sidebar={<Sidebar collapsed={sidebarCollapsed} onToggleCollapse={setSidebarCollapsed} />}
      mobileSidebar={<Sidebar collapsed={false} onToggleCollapse={() => undefined} />}
      topbarTitle="漫画広告"
    >
      <div className="flex min-h-[calc(100dvh-56px)] flex-col overflow-hidden bg-warm-bg font-sans lg:h-screen lg:min-h-0">
        {/* Header */}
        <TaskyTopBar
          title="漫画広告"
          icon={<BookOpen className="w-5 h-5" />}
          sidebarCollapsed={sidebarCollapsed}
          onExpandSidebar={() => setSidebarCollapsed(false)}
        />

        {/* Main Scrollable Content */}
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          <TaskyPageContainer>
            {/* Error Display */}
            {error && (
              <div className="bg-destructive/10 border border-destructive/30 rounded-md p-3 mb-4">
                <p className="text-sm text-destructive">{error}</p>
              </div>
            )}

            {/* Manga Generation Tab (reused component) */}
            <MangaGenerationTab
              onError={(err) => setError(err)}
            />
          </TaskyPageContainer>
        </div>
      </div>
    </ResponsiveAppShell>
  );
};

export default MangaAdsPage;
